module.exports = __webpack_public_path__ + "img/journal.6e39c1f7.svg";